
/** 设备管理页面
 */
const devFun = {
  /** 设备信息Excel导入模板下载
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  downExcelModel: function (_this, url) {
    _this.$axios({
      method: 'post',
      url: url,
      responseType: 'blob',
      data: {
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      console.log('res', res)
      /**
       * 返回值是一段流，没有{code,data,msg}结构体，所以无法判断
       */
      _this.$message({
        message: '下载成功',
        type: 'success'
      })

      const blob = res.data
      let link = document.createElement('a')
      link.href = URL.createObjectURL(
        new Blob([blob], { type: 'application/vnd.ms-excel' })
      )
      link.download = '设备批量导入(模板)'
      document.body.appendChild(link)
      link.click()
      URL.revokeObjectURL(link.href)
    }).catch(resp => {
      console.log('查询失败！' + resp)
    })
  },
  /** 批量搜索
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  listDeviceBatchSearch: function (parentThis, _this, url) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {

      },
      params: {
        imeiText: _this.imeiList,
        pageNum: _this.$parent.currentPage,
        pageSize: _this.$parent.pagesize
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        parentThis.tableData = res.data.data.pag
        parentThis.totalNum = res.data.data.total
        _this.BatchSearchVisible = false
      }
    })
  },
  /** 转移组织
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  batchUpdateDevOrgId: function (_this, url, devIds) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
      },
      params: {
        devIds: devIds,
        orgId: _this.orgId
      },
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.batchMoveVisible = false
        _this.$parent.handleNodeClick('')
        _this.$parent.clearTableSelect()
        _this.$message({
          message: '转移成功！',
          type: 'success'
        })
      } else {
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
    })
  }
}
export default devFun



// WEBPACK FOOTER //
// ./src/javascript/function/deviceFunction.js